<app-breadcrumb master="Administracja" [parentName]="'Działy'" [name]="'Lista'"></app-breadcrumb>
<div class="department-list-container">
  <form (keyup.enter)="filter()" (submit)="filter()" #filtersForm="ngForm" class="department-list-filters">
    <mat-form-field class="department-list-filter">
      <mat-label>Nazwa</mat-label>
      <input matInput placeholder="JanKow123" name="contains$name" [(ngModel)]="initialFilters.contains$name">
    </mat-form-field>

    <app-dict-departments
      class="department-list-filter" label="Dział nadrzędny"
      [multiple]="false"
      [(ngModel)]="initialFilters.parentDepartment" name="parentDepartment"
    ></app-dict-departments>

    <app-dict-users
      class="department-list-filter" label="Przełożony"
      [multiple]="false"
      [(ngModel)]="initialFilters.supervisor" name="supervisor"
    ></app-dict-users>
  </form>

  <div class="department-list-buttons">
    <button *ngIf="(userPermissions | async).department.read_report" (click)="downloadReport()" [disabled]="!(userPermissions | async).department.read_report"
            mat-raised-button class="report-button"><mat-icon>download</mat-icon> <span> Pobierz raport</span></button>
    <button (click)="filter()" mat-raised-button color="primary"><mat-icon>search</mat-icon> <span> Szukaj</span></button>
    <button (click)="resetFilters()" mat-raised-button color="warn"><mat-icon>delete</mat-icon> <span> Resetuj filtry</span></button>
  </div>

  <table mat-table [dataSource]="departments">

    <!-- Position Column -->
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef> Nazwa </th>
      <td mat-cell *matCellDef="let element">
        <a class="default-link" [routerLink]="['/uzytkownicy/dzialy/szczegoly', element.uuid]">{{element.name}}</a>
      </td>
    </ng-container>

    <ng-container matColumnDef="parentDepartment">
      <th mat-header-cell *matHeaderCellDef> Dział nadrzędny </th>
      <td mat-cell *matCellDef="let element">
        <ng-container *ngIf="element.parentDepartment">
          <a class="default-link" [routerLink]="['/uzytkownicy/dzialy/szczegoly', element.parentDepartment.uuid]">{{element.parentDepartment.name}}</a>
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="supervisor">
      <th mat-header-cell *matHeaderCellDef> Przełożony </th>
      <td mat-cell *matCellDef="let element">
        <ng-container *ngIf="element.supervisor">
          <a class="default-link" [routerLink]="['/uzytkownicy/szczegoly', element.supervisor.uuid]">{{element.supervisor.firstName}} {{element.supervisor.lastName}}</a>
        </ng-container>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="[10, 20, 50,]" [length]="totalData"></mat-paginator>
</div>
